import { AccountFrame, AccountStatus } from "@softmax/product-ux/account";
import { buildHref } from "@softmax/web-addresses";

export function AccountPending() {
  return (
    <AccountFrame
      title="Account"
      description="Manage your profile and access."
      section="settings"
      settingsHref={buildHref({ name: "account" })}
    >
      <AccountStatus state={{ status: "loading" }} onRetry={() => {}} />
    </AccountFrame>
  );
}
